export const SAMPLE_MODELS = [
  {
    name: "Sample House",
    urn: "dXJuOmFkc2sub2JqZWN0czpvcy5vYmplY3Q6dXNtMGRobWltdm5hanppdHFjaTlpcXl2YWdwY2xudHdfdHV0b3JpYWxfYnVja2V0L1RlY2huaWNhbHNjaG9vbGN1cnJlbnRtLnJ2dA==",
    description: "Basic house model for testing",
  },
];
export const LANGUAGE_KEY = "language";
export const Language = {
  En: "en",
  Hy: "hy",
};
